import { PendingCompany } from '../../../types/models/company/company.types';
import { COMPANY_ENDPOINTS } from '../../../utils/api/endpoints/companyEndpoints';

const PREFIX = '[queryPendingCompany]';

export const queryPendingCompany = async () => {
  console.log(PREFIX, `Fetching pending company infos...`);
  const response = await COMPANY_ENDPOINTS.currentPending();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received pending company infos.`);
  return json as PendingCompany;
};
